declare type SameSite = "Lax" | "None" | "Strict";

interface CookieOptions {
  expires?: number | Date; // if number: number of days from now
  path?: string;
  domain?: string;
  secure?: boolean;
  sameSite?: SameSite;
}

export const AGENT_COOKIE_NAME = "aid";
export const AFFILIATE_COOKIE_NAME = "affid";

export function getCookieValue(name: string): string {
  return document.cookie.match("(^|;)\\s*" + name + "\\s*=\\s*([^;]+)")?.pop() || "";
}

export function setCookie(cookieName: string, value: string, reload = true, override?: CookieOptions) {
  let cookieString = cookieName + "=" + value + ";";
  const options = getCookieOptions(override);
  if (options.expires) {
    if (typeof options.expires === "number") {
      const dateExpires = new Date(new Date().getTime() + options.expires * 1000 * 60 * 60 * 24);
      cookieString += "expires=" + dateExpires.toUTCString() + ";";
    } else {
      cookieString += "expires=" + options.expires.toUTCString() + ";";
    }
  }
  if (options.path) {
    cookieString += "path=" + options.path + ";";
  }
  if (options.domain) {
    cookieString += "domain=" + options.domain + ";";
  }
  if (options.secure === false && options.sameSite === "None") {
    options.secure = true;
    console.warn(`[ngx-cookie-service] Cookie ${cookieName} was forced with secure flag because sameSite=None.`);
  }
  if (options.secure) {
    cookieString += "secure;";
  }
  if (!options.sameSite) {
    options.sameSite = "Lax";
  }
  cookieString += "sameSite=" + options.sameSite + ";";

  document.cookie = cookieString; // save

  if (reload) {
    window.location.reload();
  }
}

function getMainHostName() {
  const hostName = window.location.hostname;
  const splitHostName = hostName.split(".");
  // leading dot to include subdomains
  return "." + splitHostName[splitHostName.length - 2] + "." + splitHostName[splitHostName.length - 1];
}

function getCookieOptions(override?: CookieOptions): CookieOptions {
  const hostName = window.location.hostname;
  const mainHostName = getMainHostName();
  const options: CookieOptions = {
    path: "/",
    domain: hostName == "localhost" ? undefined : mainHostName,
    secure: hostName == "localhost" ? false : true,
    sameSite: "None",
  };
  if (override) {
    Object.assign(options, override);
  }
  return options;
}
